import { graphql } from '@/graphql-setup'

export const UPLOAD_FILE_TO_ARCHIVE_MUTATION = graphql(`
  mutation FileArchiveUpload($input: CreateFileArchiveInput!) {
    createFileArchive(input: $input) {
      fileArchive {
        id
        url
      }
    }
  }
`)
